import { render, staticRenderFns } from "./InfoCardVisit.vue?vue&type=template&id=bf247970&scoped=true&"
import script from "./InfoCardVisit.vue?vue&type=script&lang=js&"
export * from "./InfoCardVisit.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardVisit.vue?vue&type=style&index=0&id=bf247970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf247970",
  null
  
)

export default component.exports